export default __webpack_public_path__ + "static/media/plus-icon.07918518.svg";